import styles from './faq.module.css';
import React, { useState } from "react";

const FAQ = () => {
    const [FAQOpen, setFAQOpen] = useState(null);

    const toggleFAQ = (index) => {
        setFAQOpen(FAQOpen === index ? null : index);
    }

    return (
        <div className={styles.faqContainer}>
            <h2>Vanligar viðmerkingar um súkkling</h2>
            <div className={styles.faq1}>
                <div className={`${styles.FAQTitle} ${FAQOpen === 1? styles.FAQTitleOpen : ''}`} onClick={() => toggleFAQ(1)}>
                    <h6>Ja, men tað eru so nógvar brekkur </h6><span>{FAQOpen === 1 ? '↑' : '↓'}</span>
                </div>
                <div className={`${styles.FAQContent} ${FAQOpen === 1? styles.FAQContentOpen : ''}`} onClick={() => toggleFAQ(1)}>
                    <p>Tað er rætt, at tað er slættari at súkkla í Danmark. Onkuntíð kann tað verða ein avbjóðing við brekkunum, men hetta kann eisini síggjast sum ein møguleiki at fáa betri kondi og styrki. Tá man hevur vant seg við brekkurnar, byrjar man at halda at tað er ein fyrimunir við brekkum tí tær gera tað meira spennandi at súkkla. Annars eru elsúkklur eisini eitt upplagt val til føroyska lendi, so ein kann ferðast skjótt runt uttan at gerast púra pøstur.</p>
                </div>
            </div>
            <div className={styles.faq2}>
                <div className={`${styles.FAQTitle} ${FAQOpen === 2? styles.FAQTitleOpen : ''}`} onClick={() => toggleFAQ(2)}>
                    <h6>Ja, men veðrið er so vánaligt </h6><span>{FAQOpen === 2 ? '↑' : '↓'}</span>
                </div>
                <div className={`${styles.FAQContent} ${FAQOpen === 2 ? styles.FAQContentOpen : ''}`} onClick={() => toggleFAQ(2)}>
                    <p>Tað er rætt, at veðrið í Føroyum kann vera ringt. Tí er sjónarmiðið hjá okkum ikki, at tað er antin súkkla ella bilur, men betraðar umstøður at koma runt sum heild – til dømis eisini við bussi. Tað snýr seg um at gera tað høgligari at velja súkkluna og aðrar ferðslumøguleikar teir dagar, har veðrið er nøkunlunda – sum als ikki er so sjálvdan heldur.</p>
                </div>
            </div>
            <div className={styles.faq3}>
                <div className={`${styles.FAQTitle} ${FAQOpen === 3? styles.FAQTitleOpen : ''}`} onClick={() => toggleFAQ(3)}>
                    <h6>Ja, men tað er so ótrygt at súkkla </h6><span>{FAQOpen === 3 ? '↑' : '↓'}</span>
                </div>
                <div className={`${styles.FAQContent} ${FAQOpen === 3 ? styles.FAQContentOpen : ''}`} onClick={() => toggleFAQ(3)}>
                    <p>Tað er rætt, at tað kann tykjast ótrygt at súkkla á ávísum støðum í Havn, serliga við nógvari bilferðslu. Svarið er at bøta um trygdina til ta ábæru ferðsluna heldur enn at raðfesta bilaferðsluna – og harvið gera súkkluviðurskiftini uppaftur ótryggari.</p>
                </div>
            </div>
            <div className={styles.faq4}>
                <div className={`${styles.FAQTitle} ${FAQOpen === 4? styles.FAQTitleOpen : ''}`} onClick={() => toggleFAQ(4)}>
                    <h6>Ja, men tað eru so fá sum súkkla </h6><span>{FAQOpen === 4 ? '↑' : '↓'}</span>
                </div>
                <div className={`${styles.FAQContent} ${FAQOpen === 4 ? styles.FAQContentOpen : ''}`} onClick={() => toggleFAQ(4)}>
                    <p>Tað eru alsamt fleiri, ið velja at súkkla. Harafturat er tað at samanbera við hønuna og eggið; eru umstøðurnar vánaligar tí tað eru fá, sum súkkla ella eru tað fá sum súkkla tí umstøðurnar eru vánaligar? Her meina vit, at umstøðurnar ávirka atferðina, og tí skulu umstøðurnar til súkklur betrast.</p>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
